module.exports = __webpack_public_path__ + "img/2024-09-19c_2.71cc7a81.jpg";